export const authRole = {
  Admin: ['admin', 'user'],
  User: ['user'],
};

export const defaultUser = {
  displayName: 'John Alex',
  email: 'demo@example.com',
  token: 'access-token',
  role: 'user',
  photoURL: '/assets/images/avatar/A11.jpg',
};
export const allowMultiLanguage = process.env.REACT_APP_MULTILINGUAL === 'true';
export const fileStackKey = process.env.REACT_APP_FILESTACK_KEY;
export const initialUrl = process.env.REACT_APP_INITIAL_URL; // this url will open after login
export const apiDocumentosBaseUrl =
  process.env.REACT_APP_API_BASE_URL || 'https://documentos.qreative.com.ar/'; // API AZURE
//export const apiDocumentosBaseUrl = 'https://localhost:44324/'; // API LOCAL
//export const apiDocumentosBaseUrl = 'https://apidocumentosadmin.qreative.ar/'; // API ADMIN
export const apiArcaBaseUrl =
  process.env.REACT_APP_ARCA_API_BASE_URL || 'https://apife.qreative.ar/'; // API ARCA
